module.exports = __webpack_public_path__ + "images/navigation/blue-ribbon-0b88c544.jpg";